import gsap from "gsap";
import GameManager from "./GameManager";
import tools from "tools";

class LocaleManager {

    constructor() {

        this.allWords = [
            "best", "newbest", "titleword1", "titleword2", "titleword3", "tuto", "try", "tryagain",
            "notry", "play", "score", "bestscore", "share", "invite", "nice", "godlike", "perfect",
            "wow", "loading", "basicTutorial", "rareTutorial", "funkyTutorial", "epicTutorial", "chestTutorial", "unlock1",
            "playWith", "currentscore", "mybestcore", "playFriends", "leaderPlay", "myscore", "canyoudobetter",
            "mission", "bounce", "times", "pass", "platforms", "scoreDaily", "points", "use", "boosters", "surpassFriend", "leaderboard"
        ];
        this._words = {};
        this._wordLoaded = 0;

    }


    init(callback) {

        console.log("init localisaion...");

        for (let i = 0; i < this.allWords.length; i++) {
            this.getWord(this.allWords[i]);
        }




        this.interval = setInterval(() => {
            // console.log(this._wordLoaded, ">=", this.allWords.length);
            if (this._wordLoaded >= this.allWords.length) {
                clearInterval(this.interval);
                this.translate();
                callback();
            }
        }, 200);


    }

    getWord(key) {

        
        GameManager.H5SDK.getI18nModule().getTranslation(key).then(value => {
            this._words[key] = value;
            this._wordLoaded++;
        });

    }

    translate() {

        // document.getElementById("loading").innerText = this._words.loading;
        // document.getElementById("best_text").innerText = this._words.best;

        let word1 = document.getElementById("title_word1");
        word1.innerText = this._words.titleword1;

        let word2 = document.getElementById("title_word2");
        word2.innerText = this._words.titleword2;

        let word3 = document.getElementById("title_word3");
        word3.innerText = this._words.titleword3;

        let infoWidth = word1.getBoundingClientRect().width + word2.getBoundingClientRect().width + word3.getBoundingClientRect().width;

        if (infoWidth > 286) {
            word1.style.fontSize = "22px";
            word2.style.fontSize = "22px";
            word3.style.fontSize = "22px";
        }

        document.getElementById("title_word2").innerText = this._words.titleword2;
        document.getElementById("title_word3").innerText = this._words.titleword3;

        let tuto = document.getElementById("tuto");
        tuto.innerText = this._words.tuto;
        tuto.style["text-align"] = "center";
        tuto.style["width"] = "200px";

        if(tools.setupIs().desktop){
            let tuto2 = document.getElementById("tuto2");
            tuto2.innerText = "or use AD / arrow keys";
            tuto2.style["text-align"] = "center";
            tuto2.style["width"] = "200px";
        }

        document.getElementById("try").innerText = this._words.try;
        document.getElementById("notry").innerText = this._words.notry;
        document.getElementById("score_text").innerText = this._words.score;
        document.getElementById("score_text").style.fontSize = "26px";
        document.getElementById("play_text").innerText = this._words.play;
        document.getElementById("share").innerText = this._words.share;
        document.getElementById("invite").innerText = this._words.invite;

    }

    get words() {
        return this._words;
    }
}
export default new LocaleManager();

